module.exports = __webpack_public_path__ + "img/welfare-ico-1.cc738c32.png";